var _defs, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarbecueAddToCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 132.03 159.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #ff5c0d;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n\n      .cls-2 {\n        fill: #e7e4e2;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 63.5,
    cy: 79.98,
    r: 63.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.48,102.82h-.03c-.89,.4-1.63,.98-2.19,1.68-.73,.9-1.14,2.03-1.23,3.19l-.13,1.65-1.19-2.74-.68-1.55c-1.29-2.96-4.74-4.32-7.7-3.03h-.03c-1.79,.79-2.99,2.36-3.38,4.14-.1,.47-.13,.96-.11,1.45l.04,1.18-.65-1.49-1.29-2.96c-1.29-2.96-4.74-4.32-7.7-3.03h-.03c-2.7,1.19-4.05,4.15-3.31,6.9l-10.31-23.67c-1.52-3.49-5.58-5.08-9.07-3.56h-.03c-3.49,1.53-5.08,5.59-3.56,9.08l18.18,41.73-1.52-.99-11.44-7.24c-3.21-2.03-7.47-1.07-9.5,2.14l-.02,.03c-2.03,3.21-1.08,7.47,2.14,9.5,0,0,1.78,1.24,2.21,1.51l8.31,5.15,18.34,11.36c1.52,1.19,5.39,3.3,5.5,3.31,6.53,2.92,14.21,3.19,21.28,.11,2.25-.98,5.13-2.47,6.94-3.94,8.33-5.92,12.1-17.53,8.05-27.97h.02s-8.23-18.9-8.23-18.9c-1.29-2.96-4.74-4.32-7.7-3.03Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 82.5,
    y1: 105.01,
    x2: 86.98,
    y2: 115.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 95.2,
    y1: 104.97,
    x2: 99.14,
    y2: 114.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 108.3,
    y1: 105.65,
    x2: 111.48,
    y2: 112.96
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.58,154.32h-28.21c-7.3,0-13.21-5.92-13.21-13.21V14.21c0-7.3,5.92-13.21,13.21-13.21h60.8c7.3,0,13.21,5.92,13.21,13.21V87.01"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 54.51,
    y1: 17.2,
    x2: 73.01,
    y2: 17.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 63.88,
    y1: 80.33,
    x2: 70.24,
    y2: 80.33
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "52.12 76.85 41.51 41.54 33.02 41.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.77,83.07c.5,3.06-2.11,5.67-5.17,5.17-1.85-.3-3.35-1.8-3.65-3.65-.5-3.06,2.11-5.67,5.17-5.17,1.85,.3,3.35,1.8,3.65,3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.11,83.07c.5,3.06-2.11,5.67-5.17,5.17-1.85-.3-3.35-1.8-3.65-3.65-.5-3.06,2.11-5.67,5.17-5.17,1.85,.3,3.35,1.8,3.65,3.65Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "44.02 48.73 88.41 48.73 80.82 71.45 50.47 71.45"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 54.63,
    y1: 49.37,
    x2: 57.19,
    y2: 65.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 65.8,
    y1: 49.37,
    x2: 65.8,
    y2: 65.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 76.98,
    y1: 49.37,
    x2: 74.41,
    y2: 65.18
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarbecueAddToCart);
export default __webpack_public_path__ + "static/media/barbecueAddToCart.09e109db52f46543e255186095bee7b1.svg";
export { ForwardRef as ReactComponent };